// extracted by mini-css-extract-plugin
export default {"iFrame":"journeyBuilder_iFrame_HLYc8"};